import * as Sentry from "@sentry/react";

import { auth$ } from "~/stores/auth";

Sentry.init({
  dsn: "https://8caeb8514a686b2629a36ac1b618b93a@o962310.ingest.us.sentry.io/4510790937083904",
  enabled: import.meta.env.PROD,
  // Route events through your server to avoid ad-blockers
  tunnel: "/api/tunnel",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    // This will send all console.error/logger.error logs to Sentry
    Sentry.consoleLoggingIntegration({
      levels: ["error"],
    }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Environment: use VITE_ so Vite exposes it to the client (e.g. set VITE_RAILWAY_ENVIRONMENT_NAME in Railway)
  environment: import.meta.env.VITE_ENV ?? "staging",
  // Link API requests to this frontend in Sentry (distributed tracing)
  tracesSampleRate: 0.8,
  tracePropagationTargets: [
    // Propagate sentry-trace and baggage to the API so backend errors link to the same trace
    import.meta.env.VITE_DOMAIN_API,
  ],
});

// Set Sentry user when auth state changes so errors and logs are attributed
auth$.onChange(
  ({ value }) => {
    const user = value?.user;
    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.email ?? undefined,
        username: user.name ?? undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  },
  { initial: true },
);
